import {FetchStatus} from '../common/FetchStatus.enum';
import useTypedSelector from '../common/useTypedSelector';
import {GroupEntity} from './types';

export function useSelectGroup(id: string): {
  group: GroupEntity;
  fetchStatus: FetchStatus;
  error: Error;
} {
  const result = useTypedSelector(state => {
    const group = state.pagewebLayout.entities.groups[id];
    const fetchStatus = state.pagewebLayout.fetchStatus[id];
    const error = state.pagewebLayout.errors[id];
    return {
      group,
      fetchStatus,
      error,
    };
  });
  return result;
}
